<template>
  <div>
    <label class="input-label">
      <div>{{label}}</div>
      <FlexRow>
        <FlexItem><input class="input-text" type="range" v-model="localValue" min="0" max="1000"></FlexItem>
        <FlexItem base="50px" :grow="0" :shrink="0" v-if="showValue" class="input-range-value">{{current}}</FlexItem>
      </FlexRow>
      <div class="input-help" v-html="help" v-if="help"></div>
    </label>
  </div>

</template>

<script>
import FlexRow from '../layout/FlexRow';
import FlexItem from '../layout/FlexItem';
export default {
  name: 'InputRange',
  components: { FlexItem, FlexRow },
  props: {
    value: {
      type: [Number]
    },
    nullValue: {
      type: Number,
      default: 0
    },
    showValue: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    }
  },
  computed: {
    current: {
      get () {
        return this.value || this.nullValue;
      }
    },
    localValue: {
      get () {
        const v = this.value || this.nullValue;
        return v === 0 ? 0 : 1000 * (v / (this.max - this.min));
      },
      set (v) {
        const finalValue = (this.max - this.min) * (v / 1000);
        this.$emit('input', finalValue);
      }
    }
  }
};
</script>
